{
  "name": "bootstrap.native",
  "version": "4.2.0",
  "description": "Native JavaScript for Bootstrap",
  "main": "dist/bootstrap-native.min.js",
  "types": "src/index.d.ts",
  "module": "dist/bootstrap-native.esm.js",
  "jsnext": "src/index.js",
  "files": [
    "dist",
    "types",
    "src"
  ],
  "scripts": {
    "test": "cypress run",
    "cypress": "npx cypress open",
    "coverage:report": "nyc report --reporter=lcov --reporter=json --reporter=text --reporter=json-summary",
    "build": "npm run lint:js && npm-run-all --parallel build-* && npm-run-all --parallel module-* && npm-run-all --parallel copy-*",
    "custom": "rollup -c --environment",
    "fix:js": "eslint src/ --config .eslintrc --fix",
    "lint:js": "eslint src/ --config .eslintrc",
    "build-esm": "rollup --environment FORMAT:esm,MIN:false -c",
    "build-esm-min": "rollup --environment FORMAT:esm,MIN:true -c",
    "build-umd": "rollup --environment FORMAT:umd,MIN:false -c",
    "build-umd-min": "rollup --environment FORMAT:umd,MIN:true -c",
    "copy-umd": "rollup --environment FORMAT:umd,MIN:false,OUTPUTFILE:./docs/assets/js/bootstrap-native.js -c",
    "build:ts": "tsc -d",
    "modules": "npm-run-all --parallel module-*",
    "module-alert-esm": "rollup --environment MODULE:alert,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-button-esm": "rollup --environment MODULE:button,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-carousel-esm": "rollup --environment MODULE:carousel,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-collapse-esm": "rollup --environment MODULE:collapse,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-dropdown-esm": "rollup --environment MODULE:dropdown,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-modal-esm": "rollup --environment MODULE:modal,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-offcanvas-esm": "rollup --environment MODULE:offcanvas,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-popover-esm": "rollup --environment MODULE:popover,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-scrollspy-esm": "rollup --environment MODULE:scrollspy,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-tab-esm": "rollup --environment MODULE:tab,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-toast-esm": "rollup --environment MODULE:toast,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-tooltip-esm": "rollup --environment MODULE:tooltip,FORMAT:esm,MIN:false -c rollup.module.js",
    "module-alert-umd": "rollup --environment MODULE:alert,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-button-umd": "rollup --environment MODULE:button,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-carousel-umd": "rollup --environment MODULE:carousel,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-collapse-umd": "rollup --environment MODULE:collapse,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-dropdown-umd": "rollup --environment MODULE:dropdown,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-modal-umd": "rollup --environment MODULE:modal,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-offcanvas-umd": "rollup --environment MODULE:offcanvas,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-popover-umd": "rollup --environment MODULE:popover,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-scrollspy-umd": "rollup --environment MODULE:scrollspy,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-tab-umd": "rollup --environment MODULE:tab,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-toast-umd": "rollup --environment MODULE:toast,FORMAT:umd,MIN:false -c rollup.module.js",
    "module-tooltip-umd": "rollup --environment MODULE:tooltip,FORMAT:umd,MIN:false -c rollup.module.js",
    "watch": "rollup --environment FORMAT:umd,MIN:false -c -w"
  },
  "browserslist": [
    "last 2 versions",
    "not <= 1%",
    "not IE 10"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/thednp/bootstrap.native.git"
  },
  "keywords": [
    "bootstrap.native",
    "bootstrap",
    "native",
    "javascript",
    "vanilla"
  ],
  "author": "dnp_theme",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/thednp/bootstrap.native/issues"
  },
  "homepage": "https://thednp.github.io/bootstrap.native/",
  "dependencies": {
    "@thednp/event-listener": "^1.0.4",
    "@thednp/shorty": "^1.0.3"
  },
  "devDependencies": {
    "@bahmutov/cypress-esbuild-preprocessor": "^2.1.3",
    "@cypress/code-coverage": "^3.9.12",
    "@rollup/plugin-buble": "^0.21.3",
    "@rollup/plugin-json": "^4.1.0",
    "@rollup/plugin-node-resolve": "^7.1.0",
    "@rollup/plugin-typescript": "^8.3.0",
    "cypress": "^9.7.0",
    "esbuild": "^0.14.30",
    "eslint": "^7.22.0",
    "eslint-config-airbnb-base": "^14.2.1",
    "eslint-plugin-import": "^2.22.1",
    "istanbul-lib-coverage": "^3.2.0",
    "istanbul-lib-instrument": "^5.2.0",
    "npm-run-all": "^4.1.5",
    "nyc": "^15.1.0",
    "rollup": "^2.38.5",
    "rollup-plugin-terser": "^5.3.1",
    "typescript": "^4.5.2"
  }
}
